const TRIOPS_CHECK_CODE_URL = 'https://clementoni-triops-3bwc5olfka-ew.a.run.app/check-code'; // Live triops
// const TRIOPS_CHECK_CODE_URL = 'https://triops-cloudrun-7gmxy4kurq-ew.a.run.app/check-code'; // Dev triops

const MSG = {
   required: "Campo obbligatorio",
   email: "Inserisci una mail valida",
   toobig: "Il file è troppo grande, inserire file inferiore a 2.5MB",
   jpg: "Inserire un\'immagine JPG",
   chars: "Il codice è di 16 caratteri",
   error: "Qualcosa è andato storto. Riprova",
   triopsCode: 'Inserisci un codice',
   loading: "Attendere prego...",
   triopsErr1: 'Errore del server. Ci contatti per favore. Errore: ',
   tripsErr2: 'Errore del server. Ci contatti per favore.',
   sending: "Invio in corso ..."
}


$(document).ready(function ()
{
   triops();
});

var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++)
{
   if (links[i].hostname !== window.location.hostname)
   {
      links[i].target = '_blank';
      links[i].relList.add('noreferrer', 'noopener');
   }
}

function triops()
{
   $('#verify_triops_submit').click(function ()
   {
      var code = $('#verify_triops').val() || '';
      var customer_id = $('#verify_triops_cusomer_id').val();
      var msg = $('#verify_triops_msg');
      var btn = $('#verify_triops_submit');
      // Clear msg
      msg.removeClass('error');
      msg.removeClass('success');
      msg.text('');

      if (!code.trim())
      {
         msg.addClass('error');
         msg.text(MSG.triopsCode);
         return;
      }

      // Disable button and add text msg loading
      btn.prop("disabled", true);
      msg.text(MSG.loading);

      $.ajax({
         url: TRIOPS_CHECK_CODE_URL,
         method: "POST",
         data: { code, customer_id },
         dataType: "json",
         success: function (data)
         {
            // Remove loading... message
            msg.text('');
            btn.prop("disabled", false);
            var classMessage = data.status ? 'success' : 'error';
            msg.addClass(classMessage);
            msg.text(data.message);
            return;
         },
         error: function (err)
         {
            const codeError = err.responseJSON && err.responseJSON.errorCode ? err.responseJSON.errorCode : null;
            const errMsg = codeError ? MSG.triopsErr1 + codeError : MSG.triopsErr2;
            // Remove loading... message
            msg.text('');
            btn.prop("disabled", false);
            msg.addClass('error');
            msg.text(errMsg);
            return;
         }
      });
   });
}

function isEmail(email)
{
   const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
   return re.test(String(email).toLowerCase());
}

function isPhone(phone)
{
   const re = /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
   return re.test(String(phone).toLowerCase());
}

// function toggleModal(){
//   $('[data-toggle="modal"]').on('click', function(){
//     $($(this).attr('data-target')).toggleClass('show');
//   });
//   $('[data-dismiss="modal"]').on('click', function(){
//     $('.modal').removeClass('show');
//   });
// } 
function toggleModal()
{
   return;
}

jQuery(document).ready(function($){
   let cfslider = $('.home-carousel-cef');
   console.log('cfslider', cfslider);
   if(cfslider.length)
   {
      
      cfslider.each(function(){
         $(this).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            cssEase: "linear",
            
            prevArrow:
             '<div class="home-carousel__nav home-carousel__nav--prev"><i class="icon icon--left-t"></i></div>',
            nextArrow:
             '<div class="home-carousel__nav home-carousel__nav--next"><i class="icon icon--right-t"></i></div>'
          });
      });
   }
});